import React, { Component } from 'react';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';

class StockPeers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            symbol: this.props.symbol,
            limit: this.props.limit
        };
    }

    componentDidMount() {
        ApiService.getStockPeers(this.state.symbol, this.state.limit)
            .then(result => {
                console.log('Stock Peers', result);
                let filteredData = [];
                if (result !== undefined && result.length !== undefined && result.length > 0 
                    && result[0].peersList !== undefined && result[0].peersList.length > 0) {
                    let peersList = result[0].peersList;
                    let length = this.state.limit === undefined ? 200 : this.state.limit;
                    length = peersList.length < length ? peersList.length : length;
                    // for (var i = 0; i < length; i++) {
                    //     filteredData.push(peersList[i]);
                    // }
                    filteredData.push(peersList);
                    console.log('stock peers filteredData', filteredData, length);
                }
                this.setState({ list: filteredData });
                console.log('stock peers list', this.state.list);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    rederSymbolRow(symbol) {
        if (symbol !== undefined) {
            let url = '/chart/' + symbol;
            return (
                <><Link to={url}>{symbol}</Link>&nbsp;&nbsp;&nbsp;</>
            )
        }
    }

    renderRow(listValue) {
        console.log('listvalue', listValue);
        return (
            <tr key={Math.random()}>
                <td style={{ overflowWrap: 'break-word'}}>{listValue.map(this.rederSymbolRow.bind(this))}</td>
            </tr>
        )
    }

    render() {
        let tableRow;
        if (this.state.list === undefined || this.state.list.length <= 0) {
            tableRow = <tr><td>No Data</td></tr>
        } else {
            tableRow = this.state.list.map(this.renderRow.bind(this));
        }

        let header = 'Stock Peers';

        return (
            <div>
                {header}
                <Table striped bordered hover size="xs" style={{ fontSize: "10px" }}>
                    <thead>
                        <tr>
                            <th>Peers&nbsp;&nbsp;
                                <OverlayTrigger
                                    placement="left"
                                    overlay={<Tooltip id="button-tooltip-2" style={{ wordBreak: 'break-all' }}>
                                        Peer groups refer to companies that are in the same industry or sector<br />
                                    </Tooltip>}>
                                    <i style={{ color: '#8A2BE2', fontSize: '15px' }} className={"fa fa-question-circle"}></i>
                                </OverlayTrigger>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default StockPeers;
